import { get } from 'react-hook-form';
import type { FieldErrors, FieldValues, Path } from 'react-hook-form';

export const getFormErrorMessage = <T extends FieldValues>(
    errors: FieldErrors<T>,
    path: Path<T>,
): string | undefined => {
    const error = get(errors, path);
    if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
        return error.message;
    }
    return undefined;
};
